import React from 'react';

interface AuthSurfaceProps {
  children: React.ReactNode;
  /**
   * Aplica o riscado diagonal sutil + shadow stack mais profundo
   * (usado como cartao principal das telas de auth). Default `true`.
   */
  striped?: boolean;
  /** Aplica padding 28px arredondamento extra (usado no shell-de-cartao). */
  lg?: boolean;
  className?: string;
}

/**
 * Card base das telas de auth. Substitui o `<StripedSurface>` do template
 * por uma versao que usa apenas CSS - pseudo-elemento `::before` aplica
 * o riscado 135deg em vez de SVG inline.
 *
 * Origem: templates/Login com Google/src/brand.jsx <StripedSurface>.
 */
export function AuthSurface({
  children,
  striped = true,
  lg = false,
  className,
}: AuthSurfaceProps) {
  const root = [
    'auth-surface',
    striped && 'auth-surface--striped',
    lg && 'auth-surface--lg',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={root}>{children}</div>;
}
